import { computed, Injectable, signal } from '@angular/core';

export interface QueuedToast {
    type: 'success' | 'error';
    message: string;
    dismissAfter?: number;
}

@Injectable({
    providedIn: 'root',
})
export default class LoaderService {
    private loading = false;
    private readonly _sendButtonDisabledFlag = signal<boolean>(false);
    readonly currentSendButtonDisabledFlag = computed(() => this._sendButtonDisabledFlag());
    private readonly _atachmentDisabledFlag = signal<boolean>(false);
    readonly currentAttachmentDisabledFlag = computed(() => this._atachmentDisabledFlag());
    private readonly _conversationLoadingFlag = signal<boolean>(false);
    readonly currentConversationLoadingFlag = computed(() => this._conversationLoadingFlag());
    private readonly _pendoGuideLoadingFlag = signal<boolean>(false);
    readonly currentPendoGuideLoadingFlag = computed(() => this._pendoGuideLoadingFlag());
    private readonly _queuedToast = signal<QueuedToast | null>(null);
    readonly currentQueuedToast = computed(() => this._queuedToast());

    /**
     *
     * @param value
     */
    setSendButtonDisabledFlag(value: boolean) {
        this._sendButtonDisabledFlag.set(value);
    }

    /**
     *
     * @param value
     */
    setAttachmentDisabledFlag(value: boolean) {
        this._atachmentDisabledFlag.set(value);
    }

    /**
     *
     * @param value
     */
    setConversationLoadingFlag(value: boolean) {
        this._conversationLoadingFlag.set(value);
    }

    /**
     *
     * @param value
     */
    setPendoGuideLoadingFlag(value: boolean) {
        this._pendoGuideLoadingFlag.set(value);
    }

    /**
     *
     * @param toast
     */
    setQueuedToast(toast: QueuedToast) {
        this._queuedToast.set(toast);
    }

    /**
     *
     */
    consumeQueuedToast(): QueuedToast | null {
        const toast = this._queuedToast();
        this._queuedToast.set(null);
        return toast;
    }

    /**
     *
     * @param loading
     */
    setLoading(loading: boolean) {
        this.loading = loading;
    }

    /**
     *
     */
    getLoading(): boolean {
        return this.loading;
    }
}
